import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
import Home from './pages/Home.jsx';

// Compare against the string: CRA inlines env vars as strings, so the literal
// "false" is truthy and a plain !REACT_APP_GA4_DISABLED check disables GA4
// exactly when it is configured to be on.
if (process.env.REACT_APP_GA4_DISABLED !== 'true' && process.env.REACT_APP_GA4_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID);
}

export default function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
      </Switch>
      <Footer />
    </Router>
  );
}
